/**
 * Schedule work for the browser's idle time, with a deadline so it still runs
 * on browsers without requestIdleCallback. Returns a canceller.
 */
export function runWhenIdle(
  callback: () => void,
  { timeoutMs, fallbackDelayMs = timeoutMs }: { timeoutMs: number; fallbackDelayMs?: number },
): () => void {
  if (typeof window.requestIdleCallback === 'function') {
    const handle = window.requestIdleCallback(callback, { timeout: timeoutMs });
    return () => window.cancelIdleCallback(handle);
  }

  const handle = window.setTimeout(callback, fallbackDelayMs);
  return () => window.clearTimeout(handle);
}
